// extracted by mini-css-extract-plugin
module.exports = {"languages":"style_languages__3bMqV","language":"style_language__rnNUG","active":"style_active__1QDjB","flag":"style_flag__3rkYd"};